export function hrDocumentGroup(name: string): string {
  const value = (name || "").toLowerCase().replace(/[_—–-]+/g, " ");
  if (/наркол|психоневр|туберк|судим|criminal|medical/.test(value)) return "Справки";
  if (/образован|диплом|сертификат|diplom|diploma|education|certificate/.test(value)) return "Образование";
  if (/справк|bank statement/.test(value)) return "Справки";
  if (/приказ|(^|\s)order(\s|\.|$)/.test(value)) return "Приказы";
  if (/заявлен|application/.test(value)) return "Заявления";
  return "Остальные документы";
}

export function groupHrDocuments<T>(items: T[], name: (item: T) => string) {
  const names = ["Справки", "Приказы", "Заявления", "Образование", "Остальные документы"];
  return names.map(label => ({
    name: label,
    items: items.filter(item => hrDocumentGroup(name(item)) === label),
  })).filter(group => group.items.length > 0);
}
